import React, { useEffect, useRef } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js"; // Ensure the correct imports

// Register chart.js components
Chart.register(ArcElement, Tooltip, Legend);

const GaugeChart = ({ value }) => {
    const chartRef = useRef(null);

    const data = {
        datasets: [
            {
                data: [33.3, 33.3, 33.3],
                backgroundColor: ["#d9534f", "#f0ad4e", "#5cb85c"],
                borderRadius: 50,
                borderWidth: 5,
                circumference: 180,
                rotation: 270,
                cutout: "85%",
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
        },
        animation: false,
    };

    // Custom plugin for main point
    const mainPointPlugin = {
        id: "mainPoint",
        afterDatasetDraw(chart) {
            const { ctx } = chart;
            const meta = chart.getDatasetMeta(0);
            const arc = meta.data[0];

            if (!arc) return;

            const cx = arc.x;
            const cy = arc.y;
            const radius = (arc.outerRadius + arc.innerRadius) / 2;

            const angle = Math.PI + (value / 100) * Math.PI;

            const dx = Math.cos(angle) * radius;
            const dy = Math.sin(angle) * radius;

            ctx.save();
            ctx.beginPath();
            ctx.arc(cx + dx, cy + dy, 15, 0, Math.PI * 2);
            ctx.fillStyle = "white";
            ctx.fill();
            ctx.lineWidth = 10;
            ctx.strokeStyle = "#002f87";
            ctx.stroke();
            ctx.restore();
        },
    };

    useEffect(() => {
        const chart = chartRef.current;

        if (chart) {
            chart.update(); // Access the chart instance directly, no need for `chartRef.current.chart`
        }
    }, [value]);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Doughnut
                ref={chartRef}
                data={data}
                options={options}
                plugins={[mainPointPlugin]}
            />
        </div>
    );
};

export default GaugeChart;
